import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="relative overflow-hidden bg-[#FFF8EE] pt-28 pb-20 min-h-screen">
      {/* Background Gradients */}
      <div className="absolute top-[-250px] left-[-200px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.12)_0%,transparent_70%)] pointer-events-none" />
      <div className="absolute bottom-[-300px] right-[-200px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(104,138,94,0.1)_0%,transparent_70%)] pointer-events-none" />

      <div className="relative z-20 max-w-[960px] mx-auto px-6">
        <div className="rounded-[40px] border border-[#F4D9B5] bg-white/70 backdrop-blur-2xl p-8 md:p-14 shadow-[0_20px_60px_rgba(0,0,0,0.03)]">
          <h1 className="text-[36px] md:text-[50px] font-bold text-[#111111] font-poppins mb-4" style={{ fontFamily: "Poppins" }}>Privacy Policy</h1>
          <p className="text-xs text-[#777] mb-10">Last Updated: June 29, 2026</p>
          
          <div className="prose max-w-none text-[#444] text-[15px] leading-[30px] space-y-8">
            <p>
              Welcome to Divyyog Foundation. We respect your privacy and are committed to protecting your personal data. This privacy policy explains how we collect, process, and protect your information when you use our website, mobile app, or enroll in our yoga batches.
            </p>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>1. Information We Collect</h2>
              <p>We may collect, use, and process the following categories of personal information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Identity Data:</strong> First name, last name, date of birth, gender.</li>
                <li><strong>Contact Data:</strong> Email address, mobile/telephone number, billing address.</li>
                <li><strong>Wellness Data:</strong> Optional details regarding fitness goals, health history, or special considerations to help instructors guide batches safely.</li>
                <li><strong>Technical Data:</strong> IP address, browser type, device information, operating system.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>2. How We Use Your Information</h2>
              <p>We use your personal data to provide a seamless premium wellness experience, specifically to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Register your account and enroll you in requested live batches.</li>
                <li>Securely stream online video classes and provide interactive trainer guidance.</li>
                <li>Manage payments, invoices, subscriptions, and renewals.</li>
                <li>Send notification updates regarding schedule changes, class alerts, or goals achievements.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>3. Data Security & Storage</h2>
              <p>
                We have put in place appropriate security measures to prevent your personal data from being accidentally lost, altered, or accessed in an unauthorized way. All payment details are processed securely by PCI-compliant payment gateways. We retain your personal data only as long as necessary to fulfill the purposes we collected it for.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>4. Your Legal Rights</h2>
              <p>
                Under certain laws (such as GDPR or local information technology rules), you have rights in relation to your personal data. This includes the right to request access to your personal data, request correction of inaccuracies, request deletion/erasure of data, or object to processing. To exercise any of these rights, please contact our support team.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>5. Contact Us</h2>
              <p>
                If you have any questions about this privacy policy or wish to exercise any of your rights, please email us at <strong>privacy@divyyog.org</strong> or visit our <a href="/contact" className="text-[#F29A0C] font-semibold hover:underline">Contact Page</a>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
